<h2 mat-dialog-title>Select Existing Data from PPK downloader</h2>

<mat-dialog-content class="mat-typography">
  <div *ngIf="isLoading" class="d-flex align-items-center justify-content-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <span class="ms-3 text-muted">Loading files...</span>
  </div>

  <div *ngIf="errorMsg" class="alert alert-danger">
    {{ errorMsg }}
  </div>

  <div *ngIf="!isLoading && !errorMsg && files.length === 0" class="alert alert-info">
    No .rtcm3 files found in your PPK Downloader history.
  </div>

  <div *ngIf="!isLoading && !errorMsg && files.length > 0">
    <div class="table-responsive" style="max-height: 400px;">
      <table class="table table-hover table-bordered mb-0">
        <thead class="table-light sticky-top">
          <tr>
            <th>Mountpoint</th>
            <th>Filename</th>
            <th>Size</th>
            <th>Last Modified (UTC)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let f of files" 
              [class.table-active]="selectedFile === f" 
              (click)="selectFile(f)" 
              style="cursor: pointer;">
            <td>{{ f.mountpoint }}</td>
            <td>{{ f.filename }}</td>
            <td>{{ f.size | number }} B</td>
            <td>{{ f.lastModified | date:'yyyy-MM-dd HH:mm:ss':'UTC' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="!selectedFile">Confirm</button>
</mat-dialog-actions>

